import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import BookProvider from '../../lib/bookProvider';

class TextPlayer extends PureComponent {
  static propTypes = {
    score_id: PropTypes.string.isRequired,
    playing: PropTypes.bool.isRequired,
    currentTime: PropTypes.number.isRequired
  };

  constructor(props) {
    super(props);

    this.state = {
      subtitles: []
    };
  }

  render() {
    const { subtitles } = this.state;
    const { currentTime } = this.props;
    const currentTimeStamp = currentTime * 1000;

    if (!subtitles) return <div>Loading subtitles...</div>;
    return (
      <div id={'subtitleViewer'} className={'subTitleMain'}>
        <div className={'subTitleHeader'}>{this.state.currentTime}</div>
        <div className={'subTitleContent'}>
          {subtitles.map((line, lineIndex) => {
            let lineClassName = 'subTitleLine';
            const selected =
              line.length && line[0].start < currentTimeStamp && line[line.length - 1].end > currentTimeStamp;
            if (selected) lineClassName += ' selected';
            if (line.length === 0) lineClassName += ' empty';
            return (
              <div className={lineClassName} key={'line_' + lineIndex}>
                {line.map((word, wordIndex) => {
                  const selected = word.start < currentTimeStamp && word.end > currentTimeStamp;
                  let wordClassName = 'subTitleWord';
                  if (selected) wordClassName += ' selected';
                  return (
                    <span className={wordClassName} key={'line_' + lineIndex + '_word_' + wordIndex}>
                      {word.text}
                    </span>
                  );
                })}
              </div>
            );
          })}
        </div>
      </div>
    );
  }

  componentDidMount() {
    this.asyncComponentDidMount().finally();
  }

  async asyncComponentDidMount() {
    const { score_id } = this.props;
    const subtitles = await BookProvider.getSubtitles(score_id);
    this.setState({ subtitles });
  }

  componentDidUpdate(prevProps, prevState) {
    if (prevProps.currentTime !== this.props.currentTime) {
      const selectedLine = document.querySelector('.subTitleLine.selected');
      if (selectedLine) {
        const paper = document.querySelector('.Main-Score.Karaoke-Main-Score');
        if (selectedLine.offsetTop >= paper.clientHeight / 2) {
          paper.scrollTop = selectedLine.offsetTop - paper.clientHeight / 2;
        }
      }
    }
  }
}

export default TextPlayer;
